import { useMemo } from 'react';
import { ApolloError } from '@apollo/client';

import { useErpLessonHomeworkSubmissionsQuery } from 'core/graphql';

import { IHomeworkRosterRow } from './homeworkModel';

interface ILessonHomeworkSubmissionsHook {
  rows: IHomeworkRosterRow[];
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
}

/**
 * Spec 0012 — per-student drill-down of one lesson's homework
 * (`lessonHomeworkSubmissionsForErp`): every student of the lesson with their
 * submission (or `submission: null` = not handed in), hw_mark and AI verdict.
 * Mounted lazily — the group tab renders the consuming panel only when a
 * lesson row is expanded.
 */
export const useLessonHomeworkSubmissions = (
  lessonId?: string,
): ILessonHomeworkSubmissionsHook => {
  const {
    data,
    loading,
    error,
    refetch,
  } = useErpLessonHomeworkSubmissionsQuery({
    variables: { lessonId: lessonId || '' },
    skip: !lessonId,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const rows = useMemo(() => data?.lessonHomeworkSubmissionsForErp ?? [], [
    data?.lessonHomeworkSubmissionsForErp,
  ]);

  return {
    rows,
    loading,
    error,
    refetch: () => {
      refetch();
    },
  };
};
